import { render, staticRenderFns } from "./Habits.vue?vue&type=template&id=72e8d86c&scoped=true&"
import script from "./Habits.vue?vue&type=script&lang=js&"
export * from "./Habits.vue?vue&type=script&lang=js&"
import style0 from "./Habits.vue?vue&type=style&index=0&id=72e8d86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8d86c",
  null
  
)

export default component.exports